import React from "react";
import "./TextArea.css";

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
    error?: string;
    className?: string;
    errorBorder?: boolean;
    isRequired?: boolean;
}

// ✅ forwardRef so React Hook Form Controller can pass ref
const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
    ({ label, error, className = "", style, errorBorder, isRequired, ...props }, ref) => {
        return (
            <div
                className={`textarea-container ${errorBorder ? "error-border" : ""} ${className}`}
                style={style}
            >
                {label && (
                    <label className="textarea-label">
                        {label}
                        {isRequired && <span className="astrikSign"> *</span>}
                    </label>
                )}
                <textarea
                    ref={ref} // ✅ ref forwarded
                    className={`textarea ${error ? "has-error" : ""}`} // ✅ safer class handling
                    {...props}
                />
                {error && <p className="textarea-error-message">{error}</p>}
            </div>
        );
    }
);

TextArea.displayName = "TextArea"; // ✅ helps with debugging

export default TextArea;
